import { render, staticRenderFns } from "./app.vue?vue&type=template&id=521bf869&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nanonum/Dropbox/WORKS/epoch/mtm_2021winter/dev_mtm2021/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521bf869')) {
      api.createRecord('521bf869', component.options)
    } else {
      api.reload('521bf869', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=521bf869&", function () {
      api.rerender('521bf869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/app.vue"
export default component.exports